import { Component, Input, TrackByFunction } from '@angular/core';
import { LoadingStatus } from '../../../shared/parameterTypes';
import {
  EnergyTableItem,
  EnergyTableItemCategory,
} from '../../../shared/services/data.service';
import { AssetService } from 'src/app/modules/shared/services/asset.service';

let componentId = 0;

@Component({
  selector: 'app-energy-table',
  templateUrl: './energy-table.component.html',
  styleUrls: ['./energy-table.component.scss'],
  standalone: false,
})
export class EnergyTableComponent {
  @Input() type!: EnergyTableItemCategory;

  @Input() batteryCharge: number | null = null;

  @Input() tableItems: EnergyTableItem[] = [];

  @Input() status: LoadingStatus = 'pending';

  @Input() shouldAnnounce = true;

  readonly accessibilityTitleId = `et-${componentId++}-title`;

  constructor(public assetService: AssetService) {}

  public trackByEnergyItem: TrackByFunction<EnergyTableItem> = (index, item) =>
    item.type + item.category;
}
